import { Route, Routes } from "react-router-dom";
import "./App.css";
import HomeWeb from "./pages/Website/Home/HomeWeb";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.css";
import {
  Clients,
  ClientsCreate,
  HomeDash,
  LoginDash,
  ProjectDetail,
  Projects,
  ProjectsCreate,
  RegisterDash,
  RequireAuth,
  Services,
  ServicesCreate,
  SocialLinks,
  SocialLinksCreate,
  Tags,
  TagsCreate,
  Testimonial,
} from "./pages/Dashboard";
import {
  Contact,
  Portfolio,
  PortfolioProjectDetail,
  RateUs,
  ServicesWeb,
} from "./pages/Website";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<HomeWeb />} />
        <Route path="/login" element={<LoginDash />} />
        <Route path="/register" element={<RegisterDash />} />
        <Route path="/services" element={<ServicesWeb />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/portfolio/:id" element={<PortfolioProjectDetail />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/rate-us" element={<RateUs />} />

        <Route element={<RequireAuth />}>
          <Route path="/panel" element={<HomeDash />}>
            <Route path="social-links/create" element={<SocialLinksCreate />} />
            <Route path="social-links" element={<SocialLinks />} />
            <Route path="clients/create" element={<ClientsCreate />} />
            <Route path="clients" element={<Clients />} />
            <Route path="services/create" element={<ServicesCreate />} />
            <Route path="services" element={<Services />} />
            <Route path="tags/create" element={<TagsCreate />} />
            <Route path="tags" element={<Tags />} />
            <Route path="projects/create" element={<ProjectsCreate />} />
            <Route path="projects" element={<Projects />} />
            <Route path="projects/:id" element={<ProjectDetail />} />
            <Route path="testimonial" element={<Testimonial />} />
          </Route>
        </Route>
      </Routes>
    </div>
  );
}

export default App;
